var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFinishCheckmark = function SvgFinishCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104 104",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thank-You",
    transform: "translate(-333.000000, -314.000000)",
    stroke: "#69DB8F",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(316.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,119 C96.6142375,119 119,96.6142375 119,69 C119,41.3857625 96.6142375,19 69,19 C41.3857625,19 19,41.3857625 19,69 C19,87.7542275 29.3253347,104.096844 44.6013937,112.653238",
    id: "Oval",
    transform: "translate(69.000000, 69.000000) rotate(-150.000000) translate(-69.000000, -69.000000) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    points: "46.7480469 72.2324219 59.6425781 85.1269531 91.0654297 53.7041016"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinishCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FinishCheckmark.35c9352f.svg";
export { ForwardRef as ReactComponent };